import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "../../index.scss";
import "./Responsive.scss";

const AvangardaText = () => {
  return (
    <Container
      sm={{ span: 12 }}
      md={{ span: 12 }}
      lg={{ span: 12 }}
      xl={{ span: 12 }}
      className="container-artist-data"
    >
      <Row>
        <Col
          sm={{ span: 12 }}
          md={{ span: 11, offset: 1 }}
          lg={{ span: 11, offset: 0 }}
          xl={{ span: 11, offset: 0 }}
        >
          <div className="artist-info-text" style={{ width: "100%" }}>
            <b>Hronologija avangarde</b>
            <br />
            <br />
            <div>1921.</div>- U februaru počinje da izlazi časopis <i>Zenit</i>{" "}
            – Internacionalna revija za umetnost i kulturu. Urednik Ljubomir
            Micić. U prvom broju časopisa <i>Zenit</i> izlazi{" "}
            <i>Zenitistički manifest</i> Ivana Golla pisan na nemačkom i{" "}
            <i>Manifest zenitizma</i> čiji su potpisnici Ljubomir Micić, Ivan
            Goll i Boško Tokin. <i>Zenit</i> uspostavlja aktivnu saradnju sa
            Arhipenkom osnivačem umetničke škole u Berlinu. <br />- Branko Ve
            Poljsnski i Dragan Aleksić u Pragu priređuju zenitističke i
            dadaističke manifestacije. Osnovan umetnički klub <i>Zenit</i>.{" "}
            <br />- Zenitovi saradnici u prvoj polovini godine objavljuju
            značajna dela: Rastko Petrović{" "}
            <i>Bruleska gospodina Peruna boga groma</i>, Miloš Crnjanski{" "}
            <i>Dnevnik o Čarnojeviću</i>, Stanislav Vinaver{" "}
            <i>Gromobran Svemira</i>, Miroslav Krleža{" "}
            <i>Marginalije uz slike Petra Dobrovića</i>. Izlazi revija za
            filmsku kulturu <i>Kinofon</i>, urednik Valerij Poljanski
            <br />
            <br />
            <div>1922.</div>- Časopis <i>Putevi</i> izlazi u Beogradu, a
            urednici i saradnici su: Milan Dedinac, Dušan Timotijević, Marko
            Ristić, Miloš Crnjanski, Rastko Petrović, Stanislav Vinaver, Dušan
            Matić, Todor Manojlović, Boško Tokin, Aleksandar Vučo i drugi.{" "}
            <br />- Rastko Petrović objavljuje knjigu <i>Otkrovenje</i>. Dragan
            Aleksić izdaje u Zagrebu dadaističke revije <i>Dada tank</i> i{" "}
            <i>Dada jazz</i>, a Branko Ve Poljanski <i>Dada-jok</i>. <br />-
            Rade Drainac pokreće časopis <i>Hipnos</i> u kome, između ostalih,
            sarađuju Moni de Buli i Rastko Petrović. <br />- Časopis novosadskih
            aktivista <i>Ut</i> pokreće Zoltan Čuka. U njemu Mihailo S. Petrov
            štampa svoje gravire. <br />- Ilija Erenburg i El Lisicki priredili{" "}
            <i>Zenit</i> br. 17/18 koji je bio posvećen novoj ruskoj umetnosti.
            El Lisicki uradio naslovnu stranu <i>Zenita</i>.<br />
            <br />
            <div>1923.</div>- Održan je performans <i>Hiljadu druga noć</i> u
            beogradskoj Kasini. Dizajn plakata potpisuje Dušan Janković, a za
            futuristički balet <i>Služiteljeva metla</i>, tekst i muziku pišu
            Marko Ristić i Miloje Milojević, dok koreografiju radi Klavdije
            Isačenko. <br />- Ljubomir Micić objavljuje manifest{" "}
            <i>Zenitizam kao balkanski totalizator novog života</i> u svom
            časopisu <i>Zenit</i> i organizuje prve zenitističke večeri u
            Beogradu i Zagrebu. <br />
            Slobodan Mišić Paležanski uređuje šabački avangardni časopis{" "}
            <i>Venturaementes</i> (Duhovi koji dolaze), od koga je izašao jedan
            broj. <br />- Dragan Aleksić objevljuje tekst{" "}
            <i>Konstruktivističko slikarstvo</i>. <br />- Ljubomir Micić prenosi
            uredništvo <i>Zenita</i> iz Zagreba u Beograd. <br />
            - Poljanski u Beogradu održao predavanje o zenitizmu i novoj
            umetnosti. <br />
            <br />
            <br />
            <div>1924.</div>- Časopis <i>Svedočanstva</i>, objavljivan je u
            Beogradu do 1925. godine, a urednici i saradnici su bili: Milan
            Dedinac, Mladen Dimitrijević, Dušan Matić, Rastko Petrović, Marko
            Ristić, Aleksandar Vučo i drugi. Ilustracije su: crtež Pabla Pikasa,
            crteži umobolnih i fotografije tatuaža. <br />- Moni de Buli izdaje
            almanah <i>Crno na belo</i>, Branko Kovačević{" "}
            <i>Almanah Branka Radičevića</i> sa fotografijama, a Dušan Jerković
            i Desimir Blagojević časopis <i>Umetnost</i>.<br />- U Beogradu se
            održava <i>Prva Zenitova međunarodna izložba nove umetnosti</i>.
            <br />- Ivan Goll saurednik <i>Zenita</i> pokreće časopis{" "}
            <i>Surrealisme</i> u Parizu. <br />
            <br />
            <div>1925.</div>- Marko Ristić objavljuje <i>Od sreće i od sna</i>,
            knjigu poezije, a Moni de Buli <i>Textes surréalistes</i> u pariskom
            časopisu <i>La Révolution surréaliste</i> (no. 5). <br />- Moni de
            Buli i Dušan Matić su među potpisnicima nadrealističke deklaracije{" "}
            <i>La révolution d’abord et toujours</i> objavljene u pariskom listu{" "}
            <i>Clarté</i>.<br />- Pokreću se novi časopisi: <i>Okno</i>, urednik
            Đorđe Jovanović, <i>Bela revija</i>, urednici Risto Ratković i B.
            Jovanović, <i>Film</i>, urednici Maksim Goranović i Boško Tokin,
            almanah <i>Čaša vode</i>, urednik Risto Ratković. Ljubomir Micić
            objavljuje poemu <i>Aeroplan bez motora</i>. <br />
            <br />
            <div>1926.</div>- Oko časopisa <i>Večnost</i> okupljaju se Risto
            Ratković, Moni de Buli, Dragan Aleksić, Dušan Jerković, Desimir
            Blagojević i drugi mladi pesnici. <br />
            - Nikola Vučo u Parizu, a Vane Živadinović Bor u Vrnjačkoj Banji
            snimaju prve serije nadrealistickih fotografija. <br />- Marko
            Ristić upoznaje Bretona i francuske nadrealiste za vreme boravka u
            Parizu i počinje da radi na ciklusu kolaža <i>
              La vie mobile
            </i>. <br />- Milan Dedinac štampa <i>Javnu pticu</i>, poemu sa
            fotomontažama. Knjige pesama objavljuju: Aleksandar Vučo{" "}
            <i>Krov nad prozorom</i>, Moni de Buli <i>Krilato zlato</i>, Branko
            Ve Poljanski <i>Tumbe</i>. Osnovana umetnička je grupa <i>Oblik</i>{" "}
            u Beogradu. <br />- Zabranjeno je izdavanje časopisa <i>Zenit</i>{" "}
            Ljubomira Micića koji je izlazio u Zagrebu i Beogradu od 1921.
            godine. <br />- Jugoslovenski zenitizam predstavljen na{" "}
            <i>Izložbi revolucionarne umetnosti</i> u Moskvi. <br />- Časopis{" "}
            <i>Zenit</i> zabranila Uprava grada Beograda, a Apelacioni sud
            podigao optužbu “da se inkriminisanim izrazima širi komunistička
            propaganda i posredno pozivaju građani da silom, putem revolucije,
            menjaju postojeći društveni poredak ugledajući se na rusku
            revoluciju” <br />
            <br />
            <div>1927.</div>- Marko i Ševa Ristić donose iz Pariza sliku Maksa
            Ernsta <i>Sova (Ptica u kavezu)</i> u Beograd (Legata Marka Ristića
            u Muzeju savremene umetnosti u Beogradu).
            <br />- Moni de Buli objavljuje <i>Antenu smrti</i> i{" "}
            <i>Leviatana</i>, zbirku poezije sa Ristom Ratkovićem, Rastko
            Petrović roman <i>Sa silama nemirljivim</i>, a Stanislav Vinaver{" "}
            <i>Ženidbu Vrapca Podunavca</i>, poemu. <br />- U almanahu{" "}
            <i>Novi istok</i> saradjuju Moni de Buli, Risto Ratković i drugi.
            <br />
            <br />
            <div>1928.</div>- Aleksandar Vučo objavio roman <i>Koren vida</i>, a
            Marko Ristić antiroman <i>Bez mere</i>. Đorđe Kostić, Oskar Davičo i
            Đorđe Jovanović pokreću časopis <i>Tragovi</i>, a Zvezdan
            Vujadinović <i>50 u Evropi</i>, koji izlazi do 1933. godine, a u
            njemu saradjuju Slobodan Kusić, Branko Milovanović, Dragan Aleksić i
            drugi. <br />
            - Vane Bor ulazi u krug francuskih nadrealista, i podstaknut
            Ernstovim delom eksperimentiše sa neslikarskim materijalima. Vane
            Bor i Marko Ristić počinju istraživanja u tehnici fotograma. <br />-
            Rastko Petrović putuje u Afriku, gde pravi seriju crteža i
            fotografija i piše putopis <i>Afrika</i> (1930). <br />- Oto Bihalji
            Merin i Pavle Bihali izdaju časopis <i>Nova literatura</i> i
            osnivaju Nolit.
            <br />
            <br />
            <div>1929.</div>
            - Đorđe Kostić, Đorđe Jovanović, Oskar Davičo i Dušan Matić rade na
            okupljanju beogradske grupe nadrealista. <br />
            - Nikola Vučo, pravi novu seriju fotografija u Parizu i Beogradu
            koje će pokloniti Muzeju primenjene umetnosti u Beogradu 1990.
            godine. <br />- Andre Tirion (André Thirion), francuski nadrealista,
            gostuje u kući Lule i Aleksandra Vuča kada nastaje serija{" "}
            <i>Le cadavre exquis</i>. <br />
            -U Beogradu boravi, u poseti kod nadrealista i Andre Žermen (André
            Germain), urednik časopisa <i>La revue européene</i>.<br />
            -Knjigu poezije objavio je Aleksandar Vučo,{" "}
            <i>Ako se još jednom setim ili načelo</i> a Đorđe Jovanović sa
            Đorđem Kostićem i Oskarom Davičom plakat <i>Četiri strane</i> itd.
            Koča Popović i Vane Bor zajedno sa francuskim umetnicima potpisuju
            protest <i>Čovek od ukusa</i> u pariskom časopisu{" "}
            <i>Revue Du Cinéma</i> (br. 3), a Moni de Buli prilazi grupi{" "}
            <i>Le Grand Jeu</i> (Velika igra), a zajedno sa Didom de Majom i
            drugim pesnicima pokreće u Parizu časopis <i>Discontinuité</i>, od
            koga je izašao samo jedan broj.
            <br />
            <br />
            <div>1930.</div>- Almanah <i>Nemoguće-Læimpossible</i> izlazi u
            Beogradu sa manifestom nadrealizma koji su potpisala trinaestorica
            članova grupe: Aleksandar Vučo, Oskar Davičo, Milan Dedinac, Mladen
            Dimitrijević, Vane Živadinović Bor, Radojica Živanović Noe, Đorđe
            Jovanović, Đorđe Kostić, Dušan Matić, Branko Milovanović, Koča
            Popović, Petar Popović i Marko Ristić. Osim beogradske grupe
            nadrealista u almanahu saradjuju: Breton, Elijar (Eluard), Pere
            (Peret), Aragon (Aragon), Sar (Char) i Tirion (Thirion). <br />-
            Prvi broj časopisa francuskih nadrealista{" "}
            <i>La surréalisme au service de la révolution</i> donosi tekst
            posvećen osnivanju beogradske grupe i njenom manifestu. <br />-
            Žan-Pol Drajfus (Jean-Paul Drenjfus) posvećuje Vanu Boru kritiku o
            filmu Frica Langa objavljenu u pariskom listu <i>Revue Du Cinéma</i>
            .<br />- Oskar Davičo i Đorđe Kostić rade seriju crteža. Aleksandar
            Vučo i Dušan Matić prave asamblaž <i>Urnebesni kliker</i>, a zajedno
            sa Lulom Vučo kolaž{" "}
            <i>Une atmosphère du printemps et de jeunesse</i>. Vane Bor radi
            seriju fotomontaža. Ljubiša Jocić izdaje prvu knjigu poezije San ili
            biljka.
            <br />
            <br />
            <div>1931.</div>
            Časopis <i>Nadrealizam danas i ovde</i> izlazi u Beogradu, a
            saradnici su: A. Vučo, O. Davičo, Dj. Jovanović, Vane Bor, R.
            Živanović Noe, M. Ristić, D. Matić, Dj. Kostić, K. Popović, P.
            Popović, a iz Francuske: S. Dali, A. Breton, R. Sar (Char), R.
            Krevel (Crevel), P. Elijar (Eluard), M. Ernst, I. Tangi (nj.
            Tangunj), T. Cara (Tzara). Likovne priloge su objavili: Radojica
            Živanovic Noe, Dušan Matić, Salvador Dali, Maks Ernst (Max Ernst),
            Iv Tangi (njves Tangunj), Alberto Djakometi (Alberto Giacometti) i
            Huan Miro (Joan Mirò). <br />- Marko Ristić i Dušan Matić objavljuju{" "}
            <i>Poziciju nadrealizma</i> koju nisu potpisali svi članovi grupe.{" "}
            <br />
            - Vane Bor upoznaje u Parizu Salvadora Dalija sa kojim će ostati u
            prepisci nekoliko godina. <br />- U časopisu{" "}
            <i>La surréalisme au service de la révolution</i> (no. 3) izlazi{" "}
            <i>Pozicija nadrealizma</i> pod naslovom "
            <i>Belgrade, 23 décembre 1930</i>" koja počinje izjavom: "Tout un
            monde contre tout un monde". Potpisnici su: Davičo, Dedinac, Vane
            Bor, Živanović Noe, Jovanović, Kostić, Matić, K. Popović, P.
            Popović, Ristić i Aleksandar Vučo. <br />- Marko Ristić i Koča
            Popović izdaju knjigu{" "}
            <i>Nacrt za jednu fenomenologiju iracionalnog</i>, a Petar Popović
            poemu <i>Neću, testera stvarnosti</i> sa fotomontažom. <br />-
            Počinju nesporazumi između nadrealista i predstavnika socijalne
            literature, odnosno između redakcija časopisa{" "}
            <i>Nadrealizam danas i ovde</i> i <i>Stožera</i>. <br />
            - Marko Ristić kratko stanuje u kući francuskih nadrealista na
            Monparnasu, 14 Rue de Château.
            <br />
            <br />
            <div>1932.</div>
            - Radojica Živanović Noe priređuje izložbu nadrealističkih slika sa
            nadrealističkim izdanjima u Umetničkom paviljonu "Cvijeta Zuzorić" u
            Beogradu. <br />- Marko Ristić i Vane Bor objavljuju knjigu{" "}
            <i>Anti-zid</i>, a Aleksandar Vučo knjige poezije{" "}
            <i>Humor zaspalo</i>, <i>Nemenikuće</i>, <i>Ćirilo i Metodije</i>.
            Dušan Matić, Oskar Davičo i Djordje Kostić izdaju knjigu{" "}
            <i>Položaj nadrealizma u društvenom procesu</i>, a Boško Tokin{" "}
            <i>Terazije</i>, roman sa fotomontažom. <br />- Posle trećeg broja
            prestaje da izlazi časopis <i>Nadrealizam danas i ovde</i>. <br />
            - Oskar Davičo je uhapšen u Bihaću, a Đorđe Jovanović i Koča Popović
            u Beogradu. Moni de Buli se seli u Pariz.
            <br />
            <br />
            <div>1933.</div>- Zbog revolucionarnih i nadrealističkih aktivnosti
            Oskar Davičo, Đorđe Jovanović i Koča Popović odlaze u zatvor u
            Sremsku Mitrovicu, a neki od njih će tu ostati par godina. Rene
            Krevel (René Crevel) tim povodom u tekstu "
            <i>Des surréalistes jougoslaves sont au bagne</i>" (Le surréalisme
            au service de la révolution, no. 6), detaljno govori o njihovom
            hapšenju i zatvaranju bez suđenja upozoravajući na pojavu nacizma i
            fašizma u Evropi. Prilozi Marka Ristića "
            <i>L’humour est–il une, attitude morale</i>" i Zdenka Rajha (Zdenko
            Reich) "<i>Préface à une étude sur la métaphore</i>" objavljeni su u
            istom broju časopisa{" "}
            <i>Le surréalisme au service de la révolution</i>. - Privatno pismo
            Vana Bora upućeno Salvadoru Daliju od 31. decembra 1932. iz Beograda
            objavljeno je takođe u tom šestom broju nadrealističkog časopisa.{" "}
            <br />- U Beogradu izlazi iz štampe knjiga za decu sa fotomontažama
            Aleksandra Vuča i Dušana Matića,{" "}
            <i>Podvizi družine "Pet petlića"</i>.<br />
            <br />
            <div>1934.</div>- U novom beogradskom časopisu <i>Danas</i>{" "}
            (urednici Milan Bogdanović i Miroslav Krleža), među saradnicima se
            nalazi i deo nadrealističke grupe: Marko Ristić, Koča Popović i Vane
            Bor. <br />- Milan Dedinac je održao predavanje{" "}
            <i>Šta je nadrealizam i šta hoće nadrealisti</i>. <br />- Ljubiša
            Jocić objavljuje knjigu pesama <i>Ljubav i sloboda</i>.<br />-
            Radojica Živanović Noe prelazi u novoosnovanu umetnicku grupu{" "}
            <i>Život</i>.<br />
            <div>1935.</div>- Vane Bor pravi seriju fotografija{" "}
            <i>Jedan minut pre zločina</i>. <br />- Aleksandar Vučo i Dušan
            Matić izdaju poemu <i>Marija Rucara</i>. <br />- Održana je prva{" "}
            <i>Medjunarodna izložba nadrealizma</i> u Kopenhagenu, a zatim će
            slične izložbe biti priredjene u Londonu (1936), Parizu (1938, 1947,
            1960), Meksiku (1940), Njujorku (1942), Pragu (1948) itd.
            <br />
            <br />
            <div>1936.</div>- Osnovan je časopis <i>Naša stvarnost</i> u
            Beogradu, a urednik je Aleksandar Vučo (do 1939). Među saradnicima
            su R. Živanović Noe i Đ. Jovanović. <br />
            - Vane Bor je postao član Filmske kulturne zadruge osnovane u
            Zemunu, zajedno sa kompozitorom Josipom Slavenskim i istoričarem
            umetnosti Jovanom Đorđevićem. U saradnji sa američkim producentom
            Ester Wonsonom (Esther Johnson) on snima film o Beogradu (nije
            sačuvan). <br />- Đorđe Kostić prisustvuje performansu Salvadora
            Dalija na otvaranju <i>Međunarodne izložbe nadrealizma</i> u
            Londonu.
            <br />
            <br />
            <div>1937.</div>- Marko Ristić objavljuje esej <i>Pablo Pikaso</i> u
            novoosnovanom zagrebačkom časopisu <i>Ars</i> (br. 2), a Milan
            Dedinac knjigu poezije <i>Jedan čovek na prozoru</i>. <br />
            - Marko i Ševa Ristić borave na Svetskoj izložbi u Parizu i posećuju
            Dalija, Tiriona, Bretona i Galeriju Gradiva. <br />
            - Koča Popović učestvuje u borbama internacionalnih brigada u
            Španiji.
            <br />
            <br />
            <div>1938.</div>-{" "}
            <i>Turpituda, "paranojačko-didaktična rapsodija"</i> Marka Ristića,
            sa crtežima Krste Hegedušića, objavljena u Zagrebu i odmah
            zaplenjena i uništena na osnovu Zakona o zaštiti javne bezbednosti i
            poretka u državi. <br />- U pariskom časopisu <i>Minotaure</i> (no.
            3–4) saradjuje Marko Ristić u Enljuête Dictionnaire abrégé du
            surréalisme. <br />- Održana je{" "}
            <i>Međunarodna izložba nadrealizma</i> u Parizu na kojoj su bila
            dela sedamdesetoro umetnika iz četrnaest zemalja: Engleske, Nemačke,
            Austrije, Belgije, Danske, Španije, Amerike, Francuske, Italije,
            Rumunije, Švedske, Švajcarske, Čehoslovačke i Japana.
            <br />
            <br />
            <div>1939.</div>- Marko Ristić pravi <i>Asamblaž</i> koji je
            sastavni deo zaostavštine umetnosti nadrealizma u Lagatu Marka
            Ristića, poklon Marka, Ševe i Mare Ristić Muzeju savremene umetnosti
            u Beogradu od 1993. godine.
            <br />
            <br />
            <br />
            <br />
          </div>

          <br />
        </Col>
      </Row>
    </Container>
  );
};

export default AvangardaText;
